import React, { FC } from "react"; 
import DetailIcon from "../../../../../images/sidebar/item-details-logo.svg";
import PricingIcon from "../../../../../images/sidebar/item-pricing-logo.svg";
import VariantIcon from "../../../../../images/sidebar/item-variants-logo.svg";
import OptionIcon from "../../../../../images/sidebar/options-icon.svg";
import ActiveDetailIcon from "../../../../../images/sidebar/selected-detail-icon.svg";
import ActivePricingIcon from "../../../../../images/sidebar/selected-pricing-icon.svg";
import ActiveVariantIcon from "../../../../../images/sidebar/selected-variant-icon.svg";
import ActiveOptionIcon from "../../../../../images/sidebar/selected-option-icon.svg";
import { observer } from "mobx-react";
import { NavigateFunction } from "react-router-dom";  
import { UpsertProductActiveStep } from "../enums";
import { SideBarContainer, SidebarSelectors } from "../styles";
import { CustomLabel, withRouter } from "@mindmemobile/mm-shared-global";

type IProps = {
  activeStep: string;
  showVariant: boolean;
  navigate: NavigateFunction;
  onTabChange: (key: string) => void;
};

interface IData {
  icon: string;
  className: string;
  title: string;
}

function getStepData(step: UpsertProductActiveStep, activeStep?: string): IData {
  let isActive = false;
  switch (step) {
      case UpsertProductActiveStep.Detail:
          isActive = activeStep == UpsertProductActiveStep.Detail;
          return {
              icon: isActive ? ActiveDetailIcon : DetailIcon,
              className: isActive ? 'active' : '',
              title: 'Details',
          } as IData;
      case UpsertProductActiveStep.Pricing:
          isActive = activeStep == UpsertProductActiveStep.Pricing;
          return {
              icon: isActive ? ActivePricingIcon : PricingIcon,
              className: isActive ? 'active' : '',
              title: 'Pricing',
          } as IData;
      case UpsertProductActiveStep.Variants:
          isActive = activeStep == UpsertProductActiveStep.Variants;
          return {
              icon: isActive ? ActiveVariantIcon : VariantIcon,
              className: isActive ? 'active' : '',
              title: 'Variants',
          } as IData;
      case UpsertProductActiveStep.Options:
          isActive = activeStep == UpsertProductActiveStep.Options;
          return {
              icon: isActive ? ActiveOptionIcon : OptionIcon,
              className: isActive ? 'active' : '',
              title: 'Options',
          } as IData;
      default:
          return {
              icon: '',
              className: '',
              title: '',
          } as IData;
  }
}
const SideBar: FC<IProps> = (props: IProps) => {
  return (
      <SideBarContainer>
          {Object.keys(UpsertProductActiveStep).map((key) => {
              const data = getStepData(
                  UpsertProductActiveStep[key as keyof typeof UpsertProductActiveStep],
                  props.activeStep,
              );
              if (
                  !props.showVariant &&
                  UpsertProductActiveStep[key as keyof typeof UpsertProductActiveStep] ===
                      UpsertProductActiveStep.Variants
              ) {
                  return null;
              }
              return (
                  <SidebarSelectors
                      key={key}
                      className={data.className}
                      onClick={() => {
                          props.onTabChange(key);
                      }}
                      style={{ cursor: 'pointer' }}
                  >
                      <img src={data.icon} />
                      <CustomLabel className="text-nowrap">{data.title}</CustomLabel>
                  </SidebarSelectors>
              );
          })}
      </SideBarContainer>
  );
};

export default withRouter(observer(SideBar));
